import { IInfoWithText } from "../../properties/InfoProperties";
import Icon from "../icons/Icon";
import { IconName } from "../icons/iconNames";

// Tone → design-system glyph. Icons come from the icon pack (never emoji), so the
// callout tints from the container's `color` like every other glass surface.
const TONE_ICON: Record<string, IconName> = {
  info: "info",
  warning: "warning",
  success: "checkCircle",
  danger: "xCircle",
};

const InfoWithText = (props: IInfoWithText) => {
  const { value, tone = "info", title } = props;
  // A titled callout is a two-line block, so the glyph anchors to the first
  // line instead of the row's middle.
  const className = `nfo-row nfo-${tone}${title ? " nfo-stacked" : ""}`;
  return (
    <div className={className} role="note">
      <span className="nfo-icon" aria-hidden="true">
        <Icon name={TONE_ICON[tone] || TONE_ICON.info} size={16} />
      </span>
      <div className="nfo-body">
        {title ? <p className="nfo-title">{title}</p> : null}
        <p className="nfo-text">{value}</p>
      </div>
    </div>
  );
};

export default InfoWithText;
